"use client"
import IconChevronLeft from "@/app/(site)/_components/Atoms/Icons/IconChevronLeft"
import IconChevronRight from "@/app/(site)/_components/Atoms/Icons/IconChevronRight"
import { useIsMobile } from "@/app/(site)/_utils/_hooks/useIsMobile"
import React, { useEffect, useRef, useState } from "react"
export default function AnimationSliderWrapper({
    children
}: {
    children: React.ReactNode
}) {
    const isMobile = useIsMobile()
    const sliderRef = useRef<HTMLDivElement>(null)
    const [isAtStart, setIsAtStart] = useState(true)
    const [isAtEnd, setIsAtEnd] = useState(false)
    const scrollPercentage = 0.4 // Adjust the scroll percentage as needed

    const handleScroll = () => {
        if (sliderRef.current) {
            setIsAtStart(sliderRef.current.scrollLeft === 0)
            setIsAtEnd(
                sliderRef.current.scrollWidth <=
                    sliderRef.current.scrollLeft + sliderRef.current.clientWidth
            )
        }
    }

    const handleScrollLeft = () => {
        if (sliderRef.current) {
            const scrollAmount = sliderRef.current.clientWidth * scrollPercentage
            sliderRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" })
        }
    }

    const handleScrollRight = () => {
        if (sliderRef.current) {
            const scrollAmount = sliderRef.current.clientWidth * scrollPercentage
            sliderRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" })
        }
    }

    const handleResize = () => {
        handleScroll()
    }

    useEffect(() => {
        if (typeof window === "undefined") return
        handleScroll()
        sliderRef.current?.addEventListener("scroll", handleScroll)
        window.addEventListener("resize", handleResize)
        return () => {
            sliderRef.current?.removeEventListener("scroll", handleScroll)
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    return (
        <div className="relative">
            {!isAtStart && !isMobile && (
                <button
                    onClick={handleScrollLeft}
                    className="absolute left-0 top-1/2 z-10 ml-8 -translate-y-1/2 transform rounded-sm bg-white p-5 md:ml-16"
                >
                    <IconChevronLeft />
                </button>
            )}
            <div
                ref={sliderRef}
                className="scrollbar-visible flex gap-16 overflow-x-scroll border-b-gray-500 pb-28 scrollbar md:gap-24 md:pb-48"
            >
                {children}
            </div>
            {!isAtEnd && !isMobile && (
                <button
                    onClick={handleScrollRight}
                    className="absolute right-0 top-1/2 mr-8 -translate-y-1/2 transform rounded-sm bg-white p-5 md:mr-16"
                >
                    <IconChevronRight />
                </button>
            )}
        </div>
    )
}
